export default __webpack_public_path__ + "static/media/RssSimple.71c1b7ee.svg";